// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__Yhp0V","contacts__body":"Contacts_contacts__body__7hbR4"};